import { onboardingApi } from ".";
import type { Signer } from "../types/signing";
import {
	fetchPackageAgreement,
	fetchPackageSigners,
	setupPackageAgreement,
} from "./endpoints/package-agreement";

const packageAgreementSlice = onboardingApi.injectEndpoints({
	endpoints: (builder) => ({
		setupPackageAgreement: builder.mutation<
			void,
			{
				applicationId: string;
			}
		>({
			query: ({ applicationId }) => setupPackageAgreement(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: false,
				withAuth: true,
			},
		}),
		fetchPackageAgreement: builder.query<string, string>({
			query: (applicationId) => fetchPackageAgreement(applicationId),
			transformResponse: (response: { document: string }) => response.document,
			extraOptions: { withAuth: true },
		}),

		fetchPackageSigners: builder.query<Signer[], string>({
			query: (applicationId) => fetchPackageSigners(applicationId),
			transformResponse: (response: { signatories: Signer[] }) => response.signatories,
			providesTags: ["CurrentApplication"],
			extraOptions: { withAuth: true },
		}),
	}),
});

export const {
	useSetupPackageAgreementMutation,
	useLazyFetchPackageAgreementQuery,
	useFetchPackageSignersQuery,
	useLazyFetchPackageSignersQuery,
} = packageAgreementSlice;
